import { ReactNode } from 'react';
import s from './ContentContainer.module.scss';

interface IContentContainerProps {
	children: ReactNode;
	className?: string;
}

export const ContentContainer = ({
	children,
	className,
}: IContentContainerProps) => {
	return <div className={`${s.contentContainer} ${className}`}>{children}</div>;
};
